import React from "react";
import { useTranslation } from "react-i18next";

import useTenantOptions from "fe-shared/src/hooks/useTenantOptions";

import { PickupRequestListItem } from "types";

import { TwoLineGridCell } from "fe-shared-requests/src/components/RequestsDataGrid/renderers";

interface Props {
  data: PickupRequestListItem;
}

const CreatedByGridCell = ({ data }: Props) => {
  const { t } = useTranslation();
  const [tenantOptions] = useTenantOptions();
  const { createdByFullName, isCreatedByInternal } = data;

  return (
    <TwoLineGridCell
      firstLineData={createdByFullName}
      secondLineData={
        isCreatedByInternal && createdByFullName
          ? t("pickupRequests.grid.createdByStaffLine", {
              tenantName: tenantOptions.tenantName,
            })
          : undefined
      }
    />
  );
};

export default CreatedByGridCell;
